import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { InputNumber } from "ng-zorro-antd/core/util";

@Component({
  selector: "reflection-pagination",
  templateUrl: "./reflection-pagination.component.html",
  styleUrls: ["./reflection-pagination.component.less"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReflectionPaginationComponent {
  @Input() @InputNumber() public pageIndex = 1;
  @Input() @InputNumber() public total = 10;
  @Input() @InputNumber() public pageSize = 10;

  @Output() public readonly pageIndexChange = new EventEmitter<number>();

  public handlePageIndexChange(page: number): void {
    this.pageIndexChange.emit(page);
  }
}
